var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 40,
    viewBox: "0 0 246 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.7151 0.362305C61.7151 3.00838 63.3279 5.27388 65.6261 6.23649C67.1134 6.86331 68.09 8.305 68.09 9.92129V39.628H74.4605V0.362305H61.7151Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.379 33.7538C178.891 33.127 177.915 31.6853 177.915 30.069V0.362305H171.544V39.628H184.29C184.29 36.982 182.677 34.7165 180.379 33.7538Z",
    fill: "#F9F9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5616 39.6286V26.8952C38.0115 26.8952 36.6048 27.4504 35.5072 28.3727C34.2529 29.4294 32.5146 29.689 31.0542 28.9458L13.4257 20.0002L31.0587 11.0546C32.5236 10.3114 34.2573 10.5711 35.5117 11.6277C36.6093 12.55 38.0205 13.1052 39.566 13.1052V0.358398L0.272705 19.9957L39.5616 39.6286Z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245.727 19.9913L206.438 0.358398V13.0918C207.989 13.0918 209.395 12.5321 210.493 11.6143C211.747 10.5576 213.485 10.298 214.946 11.0412L232.574 19.9868L214.946 28.9324C213.481 29.6756 211.747 29.4159 210.493 28.3593C209.395 27.437 207.984 26.8818 206.438 26.8818V39.6331L245.727 19.9957V19.9913Z",
    fill: "#F9F9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.641 19.9955H123C123 23.5147 125.854 26.3622 129.375 26.3622H134.993C132.699 30.6649 128.219 33.6244 123.005 33.6244C115.474 33.6244 109.368 27.5218 109.368 19.9955C109.368 12.4692 115.474 6.36669 123.005 6.36669C126.772 6.36669 130.181 7.89344 132.65 10.3604L137.157 5.85628C133.537 2.23864 128.533 0 123.009 0C111.957 0 102.997 8.95456 102.997 20C102.997 31.0454 111.957 40 123.009 40C134.061 40 143.021 31.0454 143.021 20H136.65L136.641 19.9955Z",
    fill: "#F9F9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.6455b663c3817591039f2801dd866b34.svg";
export { ForwardRef as ReactComponent };